import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  text: "I've been a residential electrician for eleven years and clients kept asking me about smart lighting and cameras. I always said no because I didn't understand the ecosystems. The module on protocols and device compatibility finally made it click, and I completed my first full smart lighting job three weeks later. I charged $1,400 and the client already referred me to his neighbor.",
  author: 'Michael Reyes',
  role: 'Residential Electrician, 38',
  location: 'Austin, Texas'
}, {
  text: "I started as a complete beginner. No electrical background, just a guy who liked tech. The Home Assistant module walked me through the install, the dashboards, the backups, everything I had failed at twice on my own. Having the checklists next to me while I worked is what made the difference. My whole house runs on automations now and two coworkers paid me to do theirs.",
  author: 'David Lindqvist',
  role: 'Warehouse Supervisor & DIY Enthusiast, 29',
  location: 'Phoenix, Arizona'
}, {
  text: "I install alarm systems and security cameras for a living, so the wiring side was familiar. What I was missing was the business half. The quotation templates and pricing worksheets changed how I talk to homeowners. I stopped guessing my prices and started sending real proposals. My average ticket went up almost 40% in two months.",
  author: 'James Whitaker',
  role: 'Security Systems Installer, 45',
  location: 'Tampa, Florida'
}, {
  text: "What I appreciated most was the troubleshooting handbook. Devices dropping off the network used to cost me entire afternoons and made me look unprofessional in front of clients. Now I follow the diagnostic sequence and I usually find the issue in minutes. The handover forms also make the end of a job feel organized instead of awkward.",
  author: 'Robert Chen',
  role: 'HVAC Technician expanding into automation, 51',
  location: 'Denver, Colorado'
}, {
  text: "I was tired of piecing things together from YouTube where every video contradicted the last one. Having one roadmap from fundamentals to client delivery saved me months. I did four paid installations in my first quarter, smart locks, thermostats and cameras, and I'm now doing this on weekends alongside my main job. The portfolio examples helped me land the very first one.",
  author: 'Carlos Marín',
  role: 'IT Support Specialist, 33',
  location: 'San Diego, California'
}];
export function Testimonials() {
  return <section className="border-y border-brand-line bg-brand-light px-4 py-5" data-id="element-161" data-mp="14tbkn6sp9iks">
      <div className="mx-auto max-w-4xl" data-id="element-162" data-mp="14r8wytf0s1j8">
        <div className="mb-3 text-center" data-id="element-163" data-mp="10s9rn7pdm2r9">
          <h2 className="mb-1 font-display text-xl font-extrabold uppercase sm:text-3xl" data-id="element-164" data-mp="10tkw79qnbejf">
            What Students Are Saying
          </h2>
          <p className="font-display text-xs font-semibold uppercase tracking-wide text-brand-orange sm:text-sm" data-id="element-165" data-mp="qtu41epk5bmi">
            ⭐⭐⭐⭐⭐ 4.9/5 — Verified Student Reviews
          </p>
        </div>
        <div className="space-y-2.5" data-id="element-166" data-mp="37fqnbic7k2x2">
          {testimonials.map(testimonial => <article key={testimonial.author} className="rounded-xl border border-brand-line bg-white p-3 shadow-sm sm:p-4" data-id="element-167" data-mp="37htkqnfowybt">
              <div className="mb-1.5 flex gap-1" aria-label="5 star rating" data-id="element-168" data-mp="3gg5cissam25u">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-brand-amber text-brand-amber" data-id="element-169" data-mp="2jol8n6i07goc" />)}
              </div>
              <p className="mb-2.5 text-sm font-normal italic leading-snug text-brand-muted sm:text-base" data-id="element-170" data-mp="2squhzt1jd405">
                “{testimonial.text}”
              </p>
              <div className="flex items-center gap-2.5 border-t border-brand-line pt-2.5" data-id="element-171" data-mp="2xjnnwk8qqidt">
                <div className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-amber/20 font-display text-base font-extrabold text-brand-orange" data-id="element-172" data-mp="20xu2sex868ep">
                  {testimonial.author.charAt(0)}
                </div>
                <div className="leading-tight" data-id="element-173" data-mp="1gyc04wcy01bh">
                  <p className="font-display text-sm font-bold text-brand-ink" data-id="element-174" data-mp="1gzn2qsunj310">
                    {testimonial.author}
                  </p>
                  <p className="text-[11px] font-semibold uppercase tracking-wide text-brand-muted" data-id="element-175" data-mp="1qw9kv9vlffzc">
                    {testimonial.role} — {testimonial.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}